import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { SyncFilesService } from '../services/sync-files.service';
import { PagerService } from 'app/shared/services/pager.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'biz-sync-files-history',
  templateUrl: './sync-files-history.component.html',
  styleUrls: ['./sync-files-history.component.scss']
})
export class SyncFilesHistoryComponent implements OnInit {
  @ViewChild("fileLink") fileLink: ElementRef;
  public paginatedData: Array<any> = [];
  public _history: Array<any> = [];  
  public pageSize = 10;
  public currentPage: number;
  @Input() isExport: boolean = true;

  constructor(private _pagerService: PagerService,
    private _translateService: TranslateService,
    private _syncFilesService: SyncFilesService) { }

  ngOnInit() {
  }

  @Input () public set data(data: any) {
    if (data && data.length > 0) {
      this._history = data;
      const begin = !this.currentPage ? 0 : this.currentPage;
      const end = begin ? begin + 1 : 1;
      this.paginatedData = this._history.slice(this.pageSize * begin, this.pageSize * end);
    }
  }

  onDownloadFile(rowKey: string, fileName: string){
    if(this.isExport){
      this._syncFilesService.downloadFileExport(fileName).then(data => {
        let file = new Blob([data], { type: "application/octet-stream" });
        this.fileLink.nativeElement.href = URL.createObjectURL(file);
        this.fileLink.nativeElement.download = fileName;
        this.fileLink.nativeElement.click();
      });
    }else{
      this._syncFilesService.downloadFileImport(fileName).then(data => {
        let file = new Blob([data], { type: "application/octet-stream" });
        this.fileLink.nativeElement.href = URL.createObjectURL(file);
        this.fileLink.nativeElement.download = fileName;
        this.fileLink.nativeElement.click();
      });
    }
  }

  onPaginationEvent(event) {
    const pager = this._pagerService.getPager(this._history.length, event.pageIndex + 1, event.pageSize);
    this.paginatedData = this._history.slice(pager.startIndex, pager.endIndex + 1);
    this.currentPage = event.pageIndex;
  }

  getFilesWithError(item,errorLog: any) {
    let filesWithError = [];
    try {
    var response =JSON.parse(errorLog);
      for (let entityKey in response) {
        let issues = response[entityKey];
        for (let issue of issues) {
          this._translateService.get(`SYNC_FILES.ERROR.${issue.IssueType}`).subscribe((message: string) => {
            filesWithError.push({
              EntitySource: issue.EntityDisplayName,
              AttributeDisplayName: issue.AttributeDisplayName,
              FileName: issue.FileName,
              IdEntityValue: issue.IdEntityValue,
              Error: message,
            });
          });
        }  
      }
      item.showDetail = true;
    }catch(e){
      item.showDetail = false;
      filesWithError = [];
    }

    return filesWithError;
  }

}
